import { Stack } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { SignerDashboardTableType, pendingRequestsTypes } from 'constants/requests.constants';
import { TableParagraph } from 'theme/elements/Paragraphs';
import { ClientPaginatedTable, ServerPaginatedTable, IServerPaginationConfig } from 'components/table';
import * as TableConfig from 'sections/Dashboard/BoSigner/tablesConfig';
import { dataType } from 'components/table/types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { getUserDetails } from 'state/reducers/user.reducers';
import { BalanceType } from 'constants/balance.constants';
import { DEFAULT_PAGE_SIZE } from 'constants/pagination.constants';

type Props = {
	title: string;
	subtitle: string;
	requests: Record<string, any>[];
	type: SignerDashboardTableType;
	pagination?: IServerPaginationConfig;
};

export const BORequests: React.FC<Props> = ({ requests, title, subtitle, type, pagination }) => {
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();
	const { permissions } = useAppSelector(getUserDetails);
	const boSignerPermission = 'bo_signer_main';
	const boSecondaryPermision = 'bo_signer_secondary';

	// permissions?.permissions && permission && permissions.permissions.includes(permission)
	const defaultSortBy =
		type === SignerDashboardTableType.COMPLETED_REQUESTS ? 'boApprovalDate' : 'boSecondarySignerApprovalDate';
	const sortableColumnsByType: Record<SignerDashboardTableType, string[]> = {
		[SignerDashboardTableType.IN_PROGRESS_REQUESTS]: ['createdAt', 'boSecondarySignerApprovalDate'],
		[SignerDashboardTableType.COMPLETED_REQUESTS]: [
			'createdAt',
			'boApprovalDate',
			'boSecondarySignerApprovalDate',
			'status',
		],
	};
	const sortableColumns = sortableColumnsByType[type] || [];
	const rowAction =
		permissions?.permissions &&
		(permissions.permissions.includes(boSignerPermission) || permissions.permissions.includes(boSecondaryPermision))
			? {
					rowAction: (row: dataType) => {
						// return false
						if (row.type === BalanceType.Topping) {
							navigate(
								`/${pagesEnum.COMPANY_FEATURE_PROFILE}/${pendingRequestsTypes.BALANCES}/${row.id}`
								//`/${pagesEnum.CUSTOMER_ACCOUNTS_DETAILS}/${row?.companyId}/${moneyActivityTypes.BALANCE}/${row.id}`
							);
						} else if (row.type === BalanceType.Withdrawal) {
							navigate(
								`/${pagesEnum.COMPANY_FEATURE_PROFILE}/${pendingRequestsTypes.BALANCES}/${row.id}`
								//`/${pagesEnum.CUSTOMER_ACCOUNTS_DETAILS}/${row?.companyId}/${customerAccountDetailsTypes.BALANCE_WITHDRAWAL}/${row.id}`
							);
						}
					},
			  }
			: {};

	// Use ServerPaginatedTable for Completed requests with pagination, ClientPaginatedTable for others
	const isCompletedWithPagination = type === SignerDashboardTableType.COMPLETED_REQUESTS && pagination;

	return (
		<Stack spacing={4}>
			<Stack spacing={2}>
				<TableParagraph title={title} text={subtitle} />
				{isCompletedWithPagination ? (
					<ServerPaginatedTable
						{...rowAction}
						defaultSortBy={defaultSortBy}
						defaultOrderBy="desc"
						data={TableConfig.tableData(requests, t)}
						columns={TableConfig.buildColumns(type, t, sortableColumns)}
						perPage={DEFAULT_PAGE_SIZE}
						serverPagination={pagination}
					/>
				) : (
					<ClientPaginatedTable
						{...rowAction}
						data={TableConfig.tableData(requests, t)}
						columns={TableConfig.buildColumns(type, t, sortableColumns)}
						defaultSortBy={defaultSortBy}
					/>
				)}
			</Stack>
		</Stack>
	);
};
